'use strict';
import { CurationDashboardOperations } from './curation-dashboard-interface';
import { IcurationWorklistItem } from '../../../interfaces/curation-worklist-item.interface';
import { CurationUtils } from '../../../utils/curation-utils';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { AddAberrationComponent } from '../../add-aberration/add-aberration.component';
import { IoptionElemet } from '../../../../shared/interfaces/IoptionElemet';
import { CurationActionCreatorService } from '../../../services/curation-action-creator.service';
import { CurationSettings } from '../curation-setting';
import { AuthenticationService } from '@ispm/user/services/authentication.service';

@Injectable()
export class curationDashboardAberrationService implements CurationDashboardOperations {
  constructor(private curationActionCreatorService: CurationActionCreatorService,
              private authService: AuthenticationService) {
  }

  adaptDataToGrid(item: IcurationWorklistItem, currentConf: any, currentUserOrgId: string) {
    CurationUtils.adaptCurationDataToGrid(item, currentConf, currentUserOrgId);
    CurationUtils.setEvidenceDisplayString(item);
  }

  adaptDataToGridWithGrantedAction(item: IcurationWorklistItem, currentUserOrgId: string, actionGrantedForType: boolean) {
    CurationUtils.adaptDataToGridWithGrantedAction(item, currentUserOrgId, actionGrantedForType);
    CurationUtils.setEvidenceDisplayString(item);
  }

  loadAddItemOptions(conf, newItemOptions: any[], curationTypeByFormName: Map<string, any>, loadFormFunc, context) {
    const formsConf = conf['ui']['forms']['createForms'];
    const snvItems: any = [];
    for (let i = 0; i < Object.keys(formsConf['SNV']).length; i++) {
      snvItems[i] = { display: formsConf['SNV'][Object.keys(formsConf['SNV'])[i]].label, code: formsConf['SNV'][Object.keys(formsConf['SNV'])[i]].formName};
    }
    const cnvItems: any = [];
    for (let i = 0; i < Object.keys(formsConf['CNV']).length; i++) {
      cnvItems[i] = { display: formsConf['CNV'][Object.keys(formsConf['CNV'])[i]].label, code: formsConf['CNV'][Object.keys(formsConf['CNV'])[i]].formName};
    }
    const fusionItems: any = [];
    fusionItems[0] = { display: formsConf['FUSION']['fusion']['label'], code: formsConf['FUSION']['fusion']['formName']};
    newItemOptions[0] = {
        label: formsConf['snvLabel'],
        command: () => {
          loadFormFunc.apply(context, [formsConf['SNV'][Object.keys(formsConf['SNV'])[0]].formName, 'SNV',
            {
              type: 'SNV', inputs: snvItems
            }]);
        }
      };

    newItemOptions[1] = {
        label: formsConf['cnvLabel'],
        command: () => {
          loadFormFunc.apply(context, [formsConf['CNV'][Object.keys(formsConf['CNV'])[0]].formName, 'CNV', {
            type: 'CNV', inputs: cnvItems
          }]);
        }
      };

    newItemOptions[2] = {
        label: formsConf['fusionLabel'],
        command: () => {
          loadFormFunc.apply(context, ['FUSION', 'FUSION', {
            type: 'Fusion', inputs: fusionItems
          }]);
        }
      };
    curationTypeByFormName.set(formsConf['FUSION']['fusion']['formName'], 'fusion');

    curationTypeByFormName.set(formsConf['CNV']['regionbased']['formName'], 'regionbased');
    curationTypeByFormName.set(formsConf['CNV']['genebased']['formName'], 'genebased');

    curationTypeByFormName.set(formsConf['SNV']['gnotation']['formName'], 'gnotation');
    curationTypeByFormName.set(formsConf['SNV']['cnotation']['formName'], 'cnotation');
    curationTypeByFormName.set(formsConf['SNV']['pnotation']['formName'], 'pnotation');
  }

  getAddButtonName() {
    return 'Add aberration';
  }

  getMockList() {
    const tempList: Array<any> = [];
    for (let i = 1; i < 100; i++) {
      tempList.push({ aberrationKey: i.toString(), status: CurationSettings.CURATION_STATUS_DRAFT, lastUpdated: i});
    }
    return Observable.of(tempList);
  }

  getCloningEnabled(): boolean {
    return true;
  }

  getCurationCreationData(itemData: { type: string; inputs: IoptionElemet[] }, formName: string) {
    const payload = {
      formName: formName,
      options: itemData.inputs,
      aberrationType: itemData.type
    };
    const data = { createComp: AddAberrationComponent, payload: payload};
    return data;
  }

  prepareCurationItem(model: any, curationType: string) {
    const disease = model.disease;
    const additionalCurationProperties = model.additionalCurationProperties;
    const diseaseDisplay = model.diseaseDisplay;
    delete model.additionalCurationProperties;
    delete model.disease;
    delete model.diseaseDisplay;
    return {
      'disease': disease,
      'diseaseDisplay': diseaseDisplay,
      'additionalCurationProperties': additionalCurationProperties,
      'type': curationType,
      'opinion': CurationUtils.buildOpinion(this.authService.user),
      'aberration': model
    };
  }

  getCurationItemByKeys(curationToCreate: any, forCurrentOrg: boolean = false) {
    return this.curationActionCreatorService.getCurationItemByKeys(curationToCreate);
  }

  createCurationItem(curationToCreate: any) {
    return this.curationActionCreatorService.createCurationItem(curationToCreate);
  }

  openEditorParams(response: any) {
    return {
      curationId: response.id,
      wfId: response.workflowRequestId,
      revisionId: response.workflowRequestActiveRevision,
      curationType: 'aberration'
    };
  }

  getCurationItem(curationItemId, revisionId, type) {
    return this.curationActionCreatorService.getCurationItem(curationItemId, revisionId);
  }

  updateDataFromModel(form: any, content: any, isClonedFromAnotherOrg: boolean, grantedActionsTable?:any){
    Object.keys(form).forEach(((key) => {
      content[key] = form[key];
    }));
  }
}
